import { CSSProperties, ReactElement } from 'react';

import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';

import { Theme, SxProps, Typography, Box } from '@mui/material';

type NuggetResourceProps = Readonly<{
  variant:
    | {
        type: 'SMALL';
        previewImage?: string;
        title: string;
      }
    | {
        type: 'LARGE';
        title: string;
        url?: string;
        previewImage?: string;
      };
}>;

export const NuggetResource = ({ variant }: NuggetResourceProps): ReactElement => {
  if (variant.type === 'LARGE') {
    return (
      <>
        {variant.previewImage && (
          <Box sx={imageContainerStyle}>
            <img src={variant.previewImage} alt={variant.title} style={imageStyle} />
          </Box>
        )}
        {variant.url && (
          <Typography
            sx={bottomTextStyle}
            variant="body1"
            onClick={() => window.open(variant.url, '_blank')}
          >
            {variant.title}
          </Typography>
        )}
      </>
    );
  }

  return (
    <>
      {variant.previewImage && (
        <Box sx={smallImageContainerStyle}>
          <img src={variant.previewImage} alt={variant.title} style={smallImageStyle} />
        </Box>
      )}
    </>
  );
};

const bottomTextStyle: SxProps<Theme> = {
  fontFamily: 'Sarabun',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  mt: 2,
  mb: 3,
  textDecoration: 'underline',
  cursor: 'pointer',
  maxWidth: '100%',
  fontStyle: 'italic',
  color: appColors.color.blue1,
};

const imageContainerStyle: SxProps<Theme> = {
  borderRadius: '16px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  width: '100%',
  mt: 2,
  objectFit: 'cover',
  aspectRatio: '16 / 9',
};

const smallImageContainerStyle: SxProps<Theme> = {
  ...imageContainerStyle,
  maxHeight: '150px',
  minHeight: 'unset',
  width: '100%',
  backgroundColor: 'transparent',
};

const imageStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '16px',
};

const smallImageStyle: CSSProperties = {
  width: '100%',
  objectFit: 'contain',
};
